import { motion } from "framer-motion";
import { ArrowRight, Users } from "lucide-react";

interface Props {
  onProceed: () => void;
}

const WelcomePage = ({ onProceed }: Props) => {
  return (
    <motion.div
      className="welcome-screen"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <motion.div
        className="welcome-card"
        initial={{ y: 50 }}
        animate={{ y: 0 }}
        transition={{ duration: 0.7 }}
      >
        <div className="welcome-icon">
          <img
            src="https://addiesafriquefoundation.org/FLOGO.jpg"
            className="logo"
          />
        </div>

        <h1>Welcome to the Addie's Afrique Course Portal</h1>

        <p>
          Access training materials, guides, tools, and resources designed to
          equip volunteers with the knowledge and skills needed to serve
          effectively and make a meaningful difference in their communities.
        </p>

        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="attendance-btn"
          onClick={onProceed}
        >
          Proceed
          <ArrowRight size={18} />
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

export default WelcomePage;
